import React from 'react';
import NumberFormat from 'react-number-format';
import classes from './InformationPage.css';
import {getIndexProtectorLabel} from "../../shared/common";
import Config from 'Config';
import {connect} from "react-redux";

const informationPage = (props) => {
    let imageUrl = Config.princeStyles + "/Report_COVER_01.png";

    const labels = [
        'Bear',
        'Little Bear',
        'Normal',
        'Little Bull',
        'Bull'
    ];

    let bgStyle = {
        backgroundImage: "url('" + imageUrl + "')"
    };

    let clientName = props.planInfo.clientInfo.firstName.value + " " + props.planInfo.clientInfo.lastName.value;
    let clientState = props.planInfo.clientInfo.state.value;
    let today = new Date();

    let mnth = null;
    let tdy = null;

    if ((today.getMonth() + 1) < 10) {
        mnth = "0" + (today.getMonth() + 1).toString();
    } else {
        mnth = (today.getMonth() + 1).toString();
    }

    if (today.getDate() < 10) {
        tdy = "0" + today.getDate().toString();
    } else {
        tdy = today.getDate().toString();
    }

    let todayStr = mnth + "/" + tdy + "/" + today.getFullYear().toString();

    const indexProtector = props.indexProtector ? props.indexProtector : 5
    let data = {};
    if (indexProtector.indexOf("INDEX ACHIEVER") !== -1) {
        const rilaData = props.productReducer.rilaData.find((element) => {
            return element.key === indexProtector;
        });
        if (props.planInfo.accountInfo.value > 250000) {
            data.sp500Minus10Percentage = rilaData.sp500Minus10PercentageOver250K;
            data.sp500OneYear50Percentage = rilaData.sp500OneYear50PercentageOver250K;
            data.sp500OneYear10Percentage = rilaData.sp500OneYear10PercentageOver250K;
            data.sp500SixYear10Percentage = rilaData.sp500SixYear10PercentageOver250K;
            data.eafeOneYear50Percenpage = rilaData.eafeOneYear50PercenpageOver250K;
            data.eafeOneYear10Percenpage = rilaData.eafeOneYear10PercenpageOver250K;
            data.realEstateOneYear50Percentage = rilaData.realEstateOneYear50PercentageOver250K;
            data.realEstateOneYear10Percentage = rilaData.realEstateOneYear10PercentageOver250K;
            data.spdrOneYear50Percentage = rilaData.spdrOneYear50PercentageOver250K;
            data.spdrOneYear10Percentage = rilaData.spdrOneYear10PercentageOver250K;
        } else {
            data.sp500Minus10Percentage = rilaData.sp500Minus10Percentage;
            data.sp500OneYear50Percentage = rilaData.sp500OneYear50Percentage;
            data.sp500OneYear10Percentage = rilaData.sp500OneYear10Percentage;
            data.sp500SixYear10Percentage = rilaData.sp500SixYear10Percentage;
            data.eafeOneYear50Percenpage = rilaData.eafeOneYear50Percenpage;
            data.eafeOneYear10Percenpage = rilaData.eafeOneYear10Percenpage;
            data.realEstateOneYear50Percentage = rilaData.realEstateOneYear50Percentage;
            data.realEstateOneYear10Percentage = rilaData.realEstateOneYear10Percentage;
            data.spdrOneYear50Percentage = rilaData.spdrOneYear50Percentage;
            data.spdrOneYear10Percentage = rilaData.spdrOneYear10Percentage;
        }
    } else {
        data = props.productReducer.productsData.find((element) => {
            return element.key === "IP" + indexProtector;
        });
    }

    console.log("IP7 Allocations: ", data);

    let clientAgeBirthField;
    let annuityInformationTable;
    if(props.companyName !== "WELLS_FARGO") {
        let dateOfBirth = props.planInfo.clientInfo.dateOfBirth.value.format("MM/DD/YYYY").toString();
        clientAgeBirthField = (
            <div className="infoSection">
                <label>Date of Birth:</label>
                <span>{dateOfBirth}</span>
            </div>
        );

        if (indexProtector === "INDEX ACHIEVER") {
            annuityInformationTable = (
                <table>
                    <thead>
                    <tr>
                        <th className="text-left">Allocation %</th>
                        <th className="text-left">Index Achiever Crediting Strategy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500Minus10Percentage}%</td>
                        <td>S&P 500® 1-Year -10% Floor with Cap - {data.sp500Minus10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500OneYear10Percentage}%</td>
                        <td>S&P 500® 1-Year 10% Buffer with Cap - {data.sp500OneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.eafeOneYear10Percenpage}%</td>
                        <td>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap - {data.eafeOneYear10Percenpage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.realEstateOneYear10Percentage}%</td>
                        <td>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap - {data.realEstateOneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.spdrOneYear10Percentage}%</td>
                        <td>SPDR Gold Shares ETF 1-Year 10% Buffer with Cap - {data.spdrOneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>

                    </tbody>
                </table>
            );
        } else if (indexProtector === "INDEX ACHIEVER ADVISORY") {
            annuityInformationTable = (
                <table>
                    <thead>
                    <tr>
                        <th className="text-left">Allocation %</th>
                        <th className="text-left">Index Achiever Crediting Strategy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500Minus10Percentage}%</td>
                        <td>S&P 500® 1-Year -10% Floor with Cap - {data.sp500Minus10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500OneYear50Percentage}%</td>
                        <td>S&P 500® 1-Year 50% Downside Participation Rate with Upside Participation Rate - {data.sp500OneYear50Percentage.value.toFixed(2)}% Participation Rate</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500OneYear10Percentage}%</td>
                        <td>S&P 500® 1-Year 10% Buffer with Cap - {data.sp500OneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.sp500SixYear10Percentage}%</td>
                        <td>S&P 500® 6-Year 10% Buffer with Upside Participation Rate - {data.sp500SixYear10Percentage.value.toFixed(2)}% Participation Rate</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.eafeOneYear10Percenpage}%</td>
                        <td>iShares MSCI EAFE ETF 1-Year 10% Buffer with Cap - {data.eafeOneYear10Percenpage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.eafeOneYear50Percenpage}%</td>
                        <td>iShares MSCI EAFE ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate - {data.eafeOneYear50Percenpage.value.toFixed(2)}% Participation Rate</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.realEstateOneYear10Percentage}%</td>
                        <td>iShares U.S. Real Estate ETF 1-Year 10% Buffer with Cap - {data.realEstateOneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.realEstateOneYear50Percentage}%</td>
                        <td>iShares U.S. Real Estate ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate - {data.realEstateOneYear50Percentage.value.toFixed(2)}% Participation Rate</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.spdrOneYear10Percentage}%</td>
                        <td>SPDR Gold Shares ETF 1-Year 10% Buffer with Cap - {data.spdrOneYear10Percentage.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.indexAchieverAllocations.spdrOneYear50Percentage}%</td>
                        <td>SPDR Gold Shares ETF 1-Year 50% Downside Participation Rate with Upside Participation Rate - {data.spdrOneYear50Percentage.value.toFixed(2)}% Participation Rate</td>
                    </tr>
                    </tbody>
                </table>
            );
        } else if (props.companyName !== "WELLS_FARGO") {
            annuityInformationTable = (
                <table>
                    <thead>
                    <tr>
                        <th className="text-left">Allocation %</th>
                        <th className="text-left">Fixed-Indexed Annuity Crediting Strategy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-center">{props.IP7Allocations.sandp}%</td>
                        <td>S&P 500 point-to point - {data.sp500.value.toFixed(2)}% Cap</td>
                    </tr>
                    {props.indexProtector != 5 && <React.Fragment><tr>
                        <td className="text-center">{props.IP7Allocations.sandrcntl}%</td>
                        <td>S&P 500 Risk Control point-to-point - {data.riskControl.value.toFixed(2)}% Participation
                            Rate
                        </td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.IP7Allocations.retiree}%</td>
                        <td>S&P U.S. Retiree Spending point-to-point - {data.retireeSpending.value.toFixed(2)}%
                            Participation Rate
                        </td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.IP7Allocations.yr}%</td>
                        <td>iShares U.S. Real Estate point-to-point - {data.yir.value.toFixed(2)}% Cap</td>
                    </tr>
                        </React.Fragment>}
                    
                    <tr>
                        <td className="text-center">{props.IP7Allocations.indexEAFE}%</td>
                        <td>iShares MSCI EAFE point-to-point with cap - {data.efa.value.toFixed(2)}% Cap</td>
                    </tr>
                    {data.barclay && (
                        <tr>
                            <td className={"text-center"}>{props.IP7Allocations.barclay}%</td>
                            <td>First Trust Barclays Edge Index 1-year point-to-point with cap - {data.barclay.value.toFixed(2)}% Cap</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            );
        } else {
            annuityInformationTable = (
                <table>
                    <thead>
                    <tr>
                        <th className="text-left">Allocation %</th>
                        <th className="text-left">Fixed-Indexed Annuity Crediting Strategy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-center">{props.IP7Allocations.sandp}%</td>
                        <td>S&P 500 point-to point - {data.sp500.value.toFixed(2)}% Cap</td>
                    </tr>
                    <tr>
                        <td className="text-center">{props.IP7Allocations.indexEAFE}%</td>
                        <td>iShares MSCI EAFE point-to-point with cap - {data.efa.value.toFixed(2)}% Cap</td>
                    </tr>
                    </tbody>
                </table>
            );
        }
    }else {
        let age = props.planInfo.clientInfo.age.value.toString();
        clientAgeBirthField = (
            <div className="infoSection">
                <label>Age:</label>
                <span>{age}</span>
            </div>
        );
    }

    return (
        <div style={bgStyle} className="InformationPage">
            <div className="infoBox">
                <h2>Plan Information</h2>
                <div className="infoSection">
                    <label>Prepared For:</label>
                    <span>{clientName}</span>
                </div>
                {clientAgeBirthField}
                <div className="infoSection">
                    <label>Date:</label>
                    <span>{todayStr}</span>
                </div>
                <div className="infoSection">
                    <label>Beginning Portfolio Value:</label>
                    <span>
                           <NumberFormat
                               value={props.portfolioInfo.begginingPortfolioValue}
                               displayType={'text'}
                               thousandSeparator={true}
                               prefix={'$'}
                               decimalScale="0"
                           />
                    </span>
                </div>
                <div className="infoSection">
                    <label className="info-title">Market Trend Assumptions:</label>
                </div>
                <div className="infoSection info-small">
                    <label>Equity Market – Years 1-3:</label>
                    <span>{labels[props.equity - 1]}</span>
                </div>
                <div className="infoSection info-small">
                    <label>Fixed-Income Market – Years 1-3:</label>
                    <span>{labels[props.interest - 1]}</span>
                </div>
                <div className="infoSection">
                    <label className="info-title">{getIndexProtectorLabel(props.indexProtector.toString())} Annuity Information:</label>
                </div>
                <div className="infoSection info-small">
                    {annuityInformationTable}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName
    }
};

export default connect(mapStateToProps)(informationPage);



// WEBPACK FOOTER //
// ./src/components/InformationPage/InformationPage.js